export default __webpack_public_path__ + "static/media/logs.c4f13001.svg";